<template>
  <div class="base">
    <inside-header back-link-name="UserIndex" color="#fff" title="账户设置" />
    <div class="main">
      <van-cell is-link to="profile">
        <a-row>
          <a-col :span="4">
            <img width="40px;" height="40px" style="border-radius: 50%" :src="profile.avatar" alt="">
          </a-col>
          <a-col :span="20">
            <div>{{ profile.nick_name }}</div>
            <div style="color: #999">
              用户名：{{ profile.username }}
            </div>
          </a-col>
        </a-row>
      </van-cell>
    </div>
    <div style="weight: 100%;height: 10px;background-color: #eee" />
    <div style="padding: 15px;">
      <van-cell title="邮箱" :value="profile.email_auth_status ? profile.email : '去设置'" is-link
        :to="{ name: 'UserSettingEmail' }" />
      <van-cell title="手机" :value="profile.phone_auth_status ? profile.phone : '去设置'" is-link
        :to="{ name: 'UserSettingPhone' }" />
      <van-cell title="微信" :value="profile.wx_auth_status ? '已绑定' : '去设置'" is-link
        :to="{ name: 'UserSettingWechat' }" />
      <van-cell title="实名认证" :value="profile.realname_status ? realname.auth_real_name : '去设置'" is-link
        :to="{ name: 'UserSettingRealname' }" />
      <van-cell title="修改密码" value="立刻修改" is-link :to="{ name: 'UserSettingPassword' }" />
      <van-button class="logout-btn" color="#efefef" round block type="info" @click="logout">
        退出登录
      </van-button>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components';
import { mapActions } from 'vuex';

export default {
  name: 'TutorPay',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
      loading: false,
      profile: {},
      realname: {}
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    ...mapActions(['UserLogout']),
    logout() {
      this.UserLogout().then(() => {
        this.$toast.success('退出账户成功');
        setTimeout(() => {
          location.reload();
        }, 1000);
      });
    },
    loadData() {
      // 加载数据
      this.loading = true;
      this.$http({
        url: '/index/user/security',
        method: 'get',
        params: {}
      }).then(res => {
        this.loading = false;
        console.log(res.data);
        if (res.status === 'success') {
          const data = res.data;
          this.profile = data.profile;
          this.realname = data.realname;
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          });
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.base {
  min-width: 280px;
  max-width: 420px;
  margin: auto;
  background-color: #fff;
}

.main {
  padding: 15px;
}

.logout-btn {
  margin-top: 20px;
  .van-button__content {
    span {
      color: #333333;
    }
  }
}
</style>
